import { csvUtils } from "../../../utils";
import { truncateSelectedValues } from "./utils";
const { isCSV , mapCSV , parseCSV  } = csvUtils;
const mapFormattedMake = (make, mappings)=>{
    const output = mappings.makes[make.toUpperCase()] ?? make;
    return output;
};
export const getFormattedMake = (make = "", mappings)=>isCSV(make) ? mapCSV(make, (part)=>mapFormattedMake(part, mappings)) : mapFormattedMake(make, mappings);
const mapFormattedModel = (model, mappings)=>mappings.models[model.toUpperCase()] ?? model;
export const getFormattedModel = (model = "", mappings)=>isCSV(model) ? mapCSV(model, (part)=>mapFormattedModel(part, mappings)) : mapFormattedModel(model, mappings);
const mapFormattedVariant = (variant, mappings)=>{
    const uppercaseVariant = variant.toUpperCase();
    return mappings.variants[uppercaseVariant] ?? variant;
};
export const getFormattedVariant = (variant = "", mappings)=>isCSV(variant) ? truncateSelectedValues(parseCSV(variant).map((element)=>mapFormattedVariant(element, mappings))) : mapFormattedVariant(variant, mappings);
